import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useQueryClientAccounts } from 'src/dataSource/api';
import { buildAlvieDatasourceOptions } from 'shared/copilot/utils/alvieDatasourceOptions';
import { type AlvieDatasourceOption } from 'shared/copilot/utils/alvieDatasourceOptions';
export interface UseAlvieDatasourceOptionsResult {
  options: AlvieDatasourceOption[];
  isLoading: boolean;
  hasConnectedSources: boolean;
  hasSources: boolean;
}
export const useAlvieDatasourceOptions = (clientId, t0) => {
  const $ = _c(11);
  const enabled = t0 === undefined ? true : t0;
  const accountsQuery = useQueryClientAccounts(clientId, enabled);
  let t1;
  if ($[0] !== accountsQuery.data) {
    t1 = accountsQuery.data ?? [];
    $[0] = accountsQuery.data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = buildAlvieDatasourceOptions(t1);
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const options = t2;
  const t3 = accountsQuery.isLoading;
  let t4;
  if ($[4] !== options) {
    t4 = options.some(_temp);
    $[4] = options;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = options.length > 0;
  let t6;
  if ($[6] !== accountsQuery.isLoading || $[7] !== options || $[8] !== t4 || $[9] !== t5) {
    t6 = {
      options,
      isLoading: t3,
      hasConnectedSources: t4,
      hasSources: t5
    };
    $[6] = accountsQuery.isLoading;
    $[7] = options;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
function _temp(option) {
  return option.connected && option.supported;
}